<template lang="pug" functional>
picture
    source(
        v-if="props.desktopSrc"
        :srcset="props.desktopSrc"
        :width="props.desktopWidth"
        :height="props.desktopHeight"
        media="(min-width: 1024px)"
    )
    source(
        v-if="props.tabletSrc"
        :srcset="props.tabletSrc"
        :width="props.tabletWidth"
        :height="props.tabletHeight"
        media="(min-width: 768px)"
    )
    //- Mobile source for: https://caniuse.com/mdn-api_htmlsourceelement_height issue in FF
    source(
        v-if="props.mobileSrc"
        :srcset="props.mobileSrc"
        :width="props.mobileWidth"
        :height="props.mobileHeight"
        media="(min-width: 0px)"
    )
    img(
        v-on="listeners"
        v-bind="data.attrs"
        :class="[data.staticClass, data.class]"
        src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='0' height='0'/>"
        :loading="props.isLazy && !props.isImportant ? 'lazy' : 'eager'"
        :fetchpriority="props.isImportant ? 'high' : 'auto'"
    )

</template>

<script>
export default {
    name: 'Picture',
    props: {
        mobileSrc: {
            type: String,
            default: null,
        },
        mobileHeight: {
            type: [String, Number],
            default: null,
        },
        mobileWidth: {
            type: [String, Number],
            default: null,
        },
        tabletSrc: {
            type: String,
            default: null,
        },
        tabletHeight: {
            type: [String, Number],
            default: null,
        },
        tabletWidth: {
            type: [String, Number],
            default: null,
        },
        desktopSrc: {
            type: String,
            default: null,
        },
        desktopHeight: {
            type: [String, Number],
            default: null,
        },
        desktopWidth: {
            type: [String, Number],
            default: null,
        },
        isLazy: {
            type: Boolean,
            default: false,
        },
        isImportant: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
